import { Component, TemplateRef, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
   styleUrls: ['./modal.component.scss']
})
export class ModalComponent {

   @ViewChild('template') template;
   @Input() dataIn:any;
   @Output() dataOut:any;

  modalRef: BsModalRef;
  config = {
    animated: true
    , data: this.dataIn
  };
  data:any;

  constructor(private modalService: BsModalService, private _router: Router) { }

  // openModal(template: TemplateRef<any>) {
  show() {
    this.modalRef = this.modalService.show(this.template, this.config);
    console.log("dataIn", this.dataIn);
    console.log("config data", this.config.data);
  }

  hide() {
   // this.pageReload();
    this.modalRef.hide();
  }
  pageReload() {
    this._router.routeReuseStrategy.shouldReuseRoute = function () { return false; };
    let currentUrl = this._router.url + '?';

    this._router.navigateByUrl(currentUrl)
      .then(() => {
        this._router.navigated = false;
        this._router.navigate([this._router.url]);

      });
  }
}




// Original
// @Component({
//   selector: 'app-modal',
//   templateUrl: './modal.component.html',
//   styleUrls: ['./modal.component.scss']
// })
// export class ModalComponent {

//   constructor() { }

//   public visible = false;
//   public visibleAnimate = false;

//   public show(): void {
//     this.visible = true;
//     setTimeout(() => this.visibleAnimate = true, 100);
//   }

//   public hide(): void {
//     this.visibleAnimate = false;
//     setTimeout(() => this.visible = false, 300);
//   }

//   public onContainerClicked(event: MouseEvent): void {
//     if ((<HTMLElement>event.target).classList.contains('modal')) {
//       this.hide();
//     }
//   }


// }



// WEBPACK FOOTER //
// ./src/app/shared-components/modal/modal.component.ts